import { RefObject } from 'react';
import { DateCustomAttribute } from '../../../../sdk/types/common/customAttribute';
import { CommonFormField } from '../../../../components/Form/CommonFormField';
import { DatePicker } from '../../../../components/DatePicker/DatePicker';
import { DateRange } from '../../../../components/DatePicker/helpers/rangeHelpers';
import { changeTimeZone } from '../../../../helpers';

export type DateAttributeFieldProps = {
  attribute: DateCustomAttribute;
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  error?: string;
  fieldRef?: RefObject<HTMLDivElement>;
};

/**
 * Layer B date field wrapper. Composes `CommonFormField` (label, asterisk
 * for `required`, inline `error` message) around `DatePicker`.
 *
 * Values are UTC-midnight timestamp strings (e.g. "1705276800000").
 */
export const DateAttributeField = ({
  attribute,
  value,
  onChange,
  disabled,
  placeholder,
  required,
  error,
  fieldRef,
}: DateAttributeFieldProps) => {
  const dateValue = value ? changeTimeZone(new Date(Number(value)), 'UTC') : null;

  const handleDateChange = (change?: DateRange | Date | null) => {
    const newDate = change instanceof Date ? change : null;
    if (newDate) {
      onChange(String(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate())));
    } else {
      onChange('');
    }
  };

  return (
    <CommonFormField label={attribute.displayName} required={required} error={error} ref={fieldRef}>
      <DatePicker
        date={dateValue}
        onChange={handleDateChange}
        disabled={disabled}
        {...(placeholder != null && { placeholder })}
        error={!!error}
        data-testId={`custom-attr-${attribute.id}`}
      />
    </CommonFormField>
  );
};
